export const stateList = [
  ['AL', 'Alabama'],
  ['AZ', 'Arizona'],
  ['AR', 'Arkansas'],
  ['CA', 'California'],
  ['CO', 'Colorado'],
  ['CT', 'Connecticut'],
  ['DE', 'Delaware'],
  ['DC', 'District Of Columbia'],
  ['FL', 'Florida'],
  ['GA', 'Georgia'],
  ['ID', 'Idaho'],
  ['IL', 'Illinois'],
  ['IN', 'Indiana'],
  ['IA', 'Iowa'],
  ['KS', 'Kansas'],
  ['KY', 'Kentucky'],
  ['LA', 'Louisiana'],
  ['MD', 'Maryland'],
  ['MA', 'Massachusetts'],
  ['MI', 'Michigan'],
  ['MN', 'Minnesota'],
  ['MS', 'Mississippi'],
  ['MO', 'Missouri'],
  ['MT', 'Montana'],
  ['NV', 'Nevada'],
  ['NH', 'New Hampshire'],
  ['NJ', 'New Jersey'],
  ['NM', 'New Mexico'],
  ['NY', 'New York'],
  ['NC', 'North Carolina'],
  ['OH', 'Ohio'],
  ['OK', 'Oklahoma'],
  ['OR', 'Oregon'],
  ['PA', 'Pennsylvania'],
  ['RI', 'Rhode Island'],
  ['SC', 'South Carolina'],
  ['TN', 'Tennessee'],
  ['TX', 'Texas'],
  ['UT', 'Utah'],
  ['VT', 'Vermont'],
  ['VA', 'Virginia'],
  ['WA', 'Washington'],
  ['WV', 'West Virginia'],
  ['WI', 'Wisconsin'],
  ['WY', 'Wyoming'],
].map((state) => ({
  value: state[0],
  text: state[1],
}));

export const provinceList = [
  ['AB', 'Alberta'],
  ['BC', 'British Columbia'],
  ['MB', 'Manitoba'],
  ['NB', 'New Brunswick'],
  ['NL', 'Newfoundland and Labrador'],
  ['NT', 'Northwest Territories'],
  ['NS', 'Nova Scotia'],
  ['NU', 'Nunavut'],
  ['ON', 'Ontario'],
  ['PE', 'Prince Edward Island'],
  ['QC', 'Quebec'],
  ['SK', 'Saskatchewan'],
  ['YT', 'Yukon Territory'],
].map((province) => ({
  value: province[0],
  text: province[1],
}));

export const businessIndustryOptions = [
  ['7001', 'Automotive Repair & Dealerships', 'AUTOMOTIVE'],
  ['7006', 'Construction & Demolition', 'CONSTRUCTION'],
  ['7011', 'Education', 'EDUCATION'],
  ['7016', 'Grocery & Convenience', 'GROCERY_AND_CONVENIENCE'],
  ['7021', 'Healthcare', 'HEALTHCARE'],
  ['7026', 'Hospitality', 'HOSPITALITY'],
  ['7031', 'Manufacturing', 'MANUFACTURING'],
  ['7036', 'Offices', 'PROFESSIONAL_SERVICES'],
  ['7041', 'Property Management', 'PROPERTY_MANAGEMENT'],
  ['7046', 'Restaurants & Bars', 'RESTAURANT'],
  ['7051', 'Retail', 'RETAIL'],
  ['7056', 'Wholesale & Warehouse', 'WHOLESALE'],
].map((option) => ({
  tid: option[0],
  name: option[1],
  field_industry_code: option[2],
}));
